import { Observable } from 'rxjs';
import { ContextMenuOptionKeyType } from './daedalus';
import { ImageFileType } from './printing';
import { ContainerButton } from './container-button';
import { TextEditorDisplaySettings } from './text-editor.service';

export type ObjectPropsWithoutPadding = Omit<ObjectProps, 'padding'>;
export type ObjectPropsMap = Record<string, Partial<ObjectPropsWithoutPadding>>;
export type ObjectPropertiesBatchUpdate = {
  objectIds: string[];
  props: Record<string, unknown>;
};
export type ObjectPropertiesUpdate = {
  objectId: string;
  props: Record<string, unknown>;
};

export interface ObjectProps {
  name?: string;
  backgroundColor: string;
  opacity?: number;
  backgroundImageUrl?: string;
  backgroundImageOpacity?: number;
  backgroundImageSize?: string;
  blur?: number;
  borderColor: string;
  borderRadius: number;
  borderSize: number;
  borderType: ObjectBorderType;
  borderVisible: boolean;
  description: string;
  descriptionDisplaySettings?: TextEditorDisplaySettings;
  padding: number;
  title: string;
  titleDisplaySettings?: TextEditorDisplaySettings;
  subtitle: string;
  subtitleDisplaySettings?: TextEditorDisplaySettings;
  footer: string;
  footerDisplaySettings?: TextEditorDisplaySettings;
  titleVisible: boolean;
  subtitleVisible: boolean;
  footerVisible: boolean;
  paddingTop?: number;
  paddingBottom?: number;
  paddingLeft?: number;
  paddingRight?: number;
  positionTop: number;
  positionLeft: number;
  shadowBlurRadius: number;
  shadowColor: string;
  shadowOffsetX: number;
  shadowOffsetY: number;
  shadowVisible: boolean;
  width: number;
  height: number;
  marginTop: number;
  marginBottom: number;
  marginLeft: number;
  marginRight: number;
  visibility: boolean;
  isMaximizable: boolean;
  showExportToCsv: boolean;
  showExportToImageIcon: boolean;
  showExportToXlsx: boolean;
  masterLinkItemName: string;
  exportContextMenuOptions?: ContextMenuOptionKeyType[];
  exportToImageFileType?: ImageFileType;
  exportToImageWidth?: number;
  exportToImageHeight?: number;
  ariaHidden?: boolean;
  buttons?: ContainerButton[];
}

export enum ObjectBorderType {
  solid = 'solid',
  dashed = 'dashed',
  dotted = 'dotted',
  double = 'double',
  none = 'none',
}

export interface IObjectPropertyAPI {
  setProperties(objectId: string, propsDiff: Partial<ObjectProps>): void;
  syncFrameProperties(objectId: string, propsDiff: Partial<ObjectProps>): void;
  syncMultipleFramesProperties(objectIds: string[], propsDiff: Partial<ObjectProps>): void;
  getProperties(objectId: string): Observable<Partial<ObjectProps>>;
  getUpdatePropsSubject(): Observable<ObjectPropertiesUpdate>;
  getBatchUpdatePropsSubject(): Observable<ObjectPropertiesBatchUpdate>;
  getProperty<T extends keyof ObjectPropsWithoutPadding>(
    objectId: string,
    property: T
  ): Required<ObjectPropsWithoutPadding>[T];
  getProperty$<T extends keyof ObjectPropsWithoutPadding>(
    objectId: string,
    property: T
  ): Observable<ObjectPropsWithoutPadding[T]>;
  getCurrentProperties(): ObjectPropsMap;
  setActiveProperties(objectId: string, props: Partial<ObjectProps>): void;
  getActiveProperties(objectId: string): Observable<Partial<ObjectProps>>;
}
